import { useAppState } from "./useReduxState"
import { FetchState, hasValue } from "../Models/Client/FetchState"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getGroundTruthTotalCount } from "../Actions/API/AppInstance/AppInstanceBaselineDataActions"
import { Result } from "../Models/Utility/Result"

export function useGroundTruthTotalCount(appID: string): FetchState<number> {
    const dispatch = useDispatch()
    const entry = useAppState(
        state => state.api.baselineData.totalCounts[appID]
    )

    useEffect(() => {
        if (entry === undefined || (hasValue(entry) && entry.value.isStale)) {
            dispatch(getGroundTruthTotalCount(appID))
        }
    }, [dispatch, appID, entry])

    return useMemo(
        () => (hasValue(entry) ? Result.ok(entry.value.value) : entry),
        [entry]
    )
}
